{
  "time": {
    "justNow": "À l'instant",
    "yesterday": "Hier",
    "minutesAgo": "Il y a {{count}} min",
    "hoursAgo": "Il y a {{count}} h",
    "daysAgo": "Il y a {{count}} j"
  },
  "panel": {
    "markAllRead": "Tout marquer comme lu",
    "clearAll": "Tout effacer",
    "clearRead": "Effacer les lus",
    "updating": "Mise à jour…",
    "clearing": "Effacement…",
    "allRead": "Tout lu",
    "unread": "{{count}} non lues",
    "markedAllRead": "Toutes les notifications marquées comme lues",
    "cleared": "Notifications effacées",
    "clearedRead": "Notifications lues effacées",
    "actionFailed": "Échec de l'action sur les notifications"
  }
}
